import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import Avatar from "../commonComponents/Avatar";
import { OverlayTrigger, Popover } from "react-bootstrap";
import authSlice from "../../store/auth/authSlice";
import TableMember from "./tableMember";

const CustomTable = (props) => {
    const dispatch = useDispatch();
    const [headers, setHeaders] = useState({});
    // const userDetails = useSelector((state) => state.auth.loggedInUser);
    let scrl = useRef(null);
    const [scrollX, setscrollX] = useState(0);
    const [scrolEnd, setscrolEnd] = useState(true);
    const iteration = 5;

    //Slide click
    const slide = (shift) => {
        scrl.current.scrollLeft += shift;
        setscrollX(scrollX + shift);
        scrollCheck();
    };

    const scrollCheck = () => {
        setscrollX(scrl.current.scrollLeft);
        if (Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <= scrl.current.offsetWidth) {
            setscrolEnd(false);
        } else {
            setscrolEnd(true);
        }
    };

    useEffect(() => {
        if (scrl.current.scrollWidth > 522 && props.roleId == 5) {
            setscrolEnd(true);
        }
        if (scrl.current.scrollWidth < 522 && props.roleId != 5) {
            setscrolEnd(true);
        }
        scrollCheck();
    }, [scrl.current]);

    useLayoutEffect(() => {

        if (scrl.current.scrollWidth > 522 && props.roleId == 5) {
            setscrolEnd(true);
        }
        if (scrl.current.scrollWidth < 522 && props.roleId != 5) {
            setscrolEnd(true);
        }

        window.addEventListener('resize', scrollCheck);
    });

    useEffect(() => {
        setHeaders({
            fixedHeaders: props.headers.slice(0, props.frozen),
            regularHeaders: props.headers.slice(props.frozen, props.headers.length)
        });



    }, [props]);

    //const onMemberClick = (data) => { }

    const addTd = (arr, table) => {
        if (arr && arr.length > 0) {
            if (table == "fixed" && props.className == "custom-activity-table-container") {
                return arr?.map((e, index) => (
                    index == 0
                        ? <td className="avatar-td" key={"sdfa" + index}>{e}</td>
                        : <td key={"asdf" + index}><span className="vertical-devider-span"></span>{e}</td>
                ));
            }
            else if (props.className == "custom-activity-table-container") {
                return arr?.map((e, index) => (
                    <td key={"bdsf" + index}><span className="vertical-devider-span"></span>{e}</td>
                ));
            }
            else if (table == "fixed" && props.className == "custom-skill-table-container") {
                return arr?.map((e, index) => (
                    <td key={"cd" + index} className="theme-td">{e}</td>
                ));
            }
            else if (props.className == "custom-skill-table-container") {
                return arr?.map((e, index) => (
                    <td key={"dsa" + index}>{e}</td>
                ));
            }
        }
    };
    const getStatus = (data) => {
        if (data.isComplete) {
            return "Completed";
        }
        else if (data.isUnlocked && !data.isCurrent) {
            return "Pending";
        }
        else if (data.isCurrent) {
            return "Started";
        }
        else {
            return <span className="locked-activity"></span>;
        }
    };
    const renderFrozenTd = (arr) => {
        const sliceArr = arr?.slice(0, headers?.fixedHeaders?.length);
        if (sliceArr && sliceArr.length > 0) {
            if (props.className == "custom-activity-table-container") {
                return sliceArr.map((e, index) => (
                    <>
                        {index === 0 && <td key={"ffdf" + index} className="avatar-td">
                            <Avatar {...e} frame="coach" className="x-small" />
                        </td>}
                        {index === 1 && <td key={"gaa" + index}><TableMember {...e} /></td>}
                        {index !== 0 && index !== 1 && <td key={"hdsfdsf" + index}>{getStatus(e)}</td>}
                    </>
                ));
            }

            if (props.className == "custom-skill-table-container") {
                return sliceArr.map((e, index) => (
                    index == 0 ? <td key={"i" + index} className="theme-td">{e}</td> : <td key={"asaf" + index}>{e}</td>
                ));
            }
        }
        scrollCheck();
    };

    const renderFrozen = (arr) => {
        if (arr && arr.length > 0) {
            return arr.map((e, index) => {
                return <>
                    <tr key={"j" + index}>{renderFrozenTd(e)}</tr>
                    {/* <tr className="blank-frozen-row" key={"jdzshbd" + index}></tr> */}
                </>;
            });
        }
    };
    const renderReularTd = (arr) => {
        const sliceArr = arr?.slice(headers?.fixedHeaders?.length, arr?.length);
        if (sliceArr && sliceArr.length > 0) {
            return sliceArr.map((e, index) => (
                // <td key={index}>{e}</td>
                <>
                    {props.isSkill &&
                        <td key={"ksadfsdaf" + index}><div className="gradient-container">
                            {
                                [...Array(iteration)].map((elementInArray, index) => (
                                    <div key={"ladf" + index} className={`progress-indicator ${index < parseInt(e) ? "transparent-bg" : ""}`}></div>
                                )
                                )}
                        </div></td>
                    }
                    {!props.isSkill &&
                        <td key={index}>{getStatus(e)}</td>
                    }
                </>
            ));
        }
    };
    const renderReular = (arr) => {
        if (arr && arr.length > 0) {
            return arr?.map((e, index) => {
                return <>
                    <tr className="regular-tr" key={"m" + index}>{renderReularTd(e)}</tr>
                    {/* <tr className="blank-regular-row" key={"mdftrtg" + index}></tr> */}
                </>;
            });

        }
    };

    const openProfile = (userid, offeringuserid) => {
        dispatch(
            authSlice.actions.setProfileData({
                userId: userid,
                offeringUserId: offeringuserid,
            })
        );
        dispatch(
            authSlice.actions.setProfileStack({
                userId: userid,
                offeringUserId: offeringuserid,
            })
        );
        dispatch(authSlice.actions.setProfileLoader({ showLoader: true }));
        dispatch(authSlice.actions.showProfile());
        setTimeout(function () {
            dispatch(authSlice.actions.setProfileLoader({ showLoader: false }));
        }, 2000);
    };

    const popover = (
        <Popover id="popover-basic" className="profilePopover">
            <div className="popover-profile-top-section">
                {/* <div className="profile-picture">
              <div className="profile-avatar">
              <UserThumbnail currentUser={true} className="profile-avatar" />
              </div>
            </div> */}
                <Avatar {...props} className="small" />
                <div className="profile-details">
                    <div className="profile-name">
                        {props.firstName + " " + props.lastName}
                    </div>
                    <div className="profile-teamname">{props.teamName}</div>
                    <div className="profile-missionname">{props.missionName}</div>
                </div>
            </div>
            <div className="popover-profile-bottom-section">
                <div className="profile-email">{props.email}</div>
                <div
                    className="profile-view"
                    onClick={() => {
                        openProfile(props.id, props.offeringUserId);
                    }}
                >
                    View Profile
                </div>
            </div>
        </Popover>
    );

    return (
        <div className={props.className}>
            {scrollX !== 0 && (
                <button
                    className="coach-activity-prev slick-arrow slick-prev"
                    onClick={() => slide(-200)}
                >
                    Prev
                </button>
            )}
            {scrolEnd && (
                <button
                    className="coach-activity-next slick-arrow slick-next"
                    onClick={() => slide(+200)}
                >
                    Next
                </button>
            )}
            <table className="fixed">
                <thead>
                    <tr>
                        {addTd(headers?.fixedHeaders, "fixed")}
                    </tr>
                </thead>
                <tbody>
                    {renderFrozen(props.data)}
                </tbody>
            </table>
            <div className="scroll" ref={scrl} onScroll={scrollCheck} onChange={scrollCheck}>
                <table className="scrollable">
                    <thead>
                        <tr>
                            {addTd(headers?.regularHeaders)}
                        </tr>
                    </thead>
                    <tbody>
                        {renderReular(props.data)}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default CustomTable;